import { Box, CircularProgress, IconButton, TableCell } from "@mui/material";
import { Link } from "react-router";
import { download, eye, linkIcon } from "../../icons";
import { isNullOrWhitespace } from "../../stringOperations";

interface DocumentAccessCellProps {
    documentId: string;
    link?: string;
    downloadingDocument?: string;
    isPreviewable: boolean;
    previewHref?: string;
    onDownloadClick: () => void;
    onPreviewClick: () => void;
}

function DocumentAccessCell(props: DocumentAccessCellProps) {
    return (
        <TableCell>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {props.documentId === props.downloadingDocument ? (
                    <CircularProgress sx={{ marginLeft: 1.2, marginTop: "4px" }} size={20} />
                ) : (
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            props.onDownloadClick();
                        }}
                    >
                        {isNullOrWhitespace(props.link) ? download : linkIcon}
                    </IconButton>
                )}
                {props.isPreviewable &&
                    (props.previewHref ? (
                        <IconButton
                            component={Link}
                            to={props.previewHref}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (e.ctrlKey || e.metaKey || e.shiftKey) {
                                    return;
                                }
                                e.preventDefault();
                                props.onPreviewClick();
                            }}
                        >
                            {eye}
                        </IconButton>
                    ) : (
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                props.onPreviewClick();
                            }}
                        >
                            {eye}
                        </IconButton>
                    ))}
            </Box>
        </TableCell>
    );
}

export default DocumentAccessCell;
